import { LocalDateTime } from "@flockcover/flock-svc-core-types"
import { RebateSummaryPeriodData } from "../../../api/rebates/useGetRebateSummary"
import { InsightsPeriod } from "../../../api/insights"

export type ChartPeriod = {
  mileage: number | null
  expectedMileage: number | null
  date: LocalDateTime
}

export const mapPeriodsToChart = (
  periods: ReadonlyArray<InsightsPeriod> | ReadonlyArray<RebateSummaryPeriodData> | undefined,
  isV2: boolean
): ReadonlyArray<ChartPeriod> => {
  if (!periods) {
    return []
  }

  if (isV2) {
    const v2Periods = periods as ReadonlyArray<InsightsPeriod>
    let mileage: number | null = 0
    return v2Periods.map((period: InsightsPeriod) => {
      if (typeof mileage === `number`) {
        mileage = typeof period?.analytics?.distance === `number` ? mileage + period.analytics.distance : null
      }
      return {
        mileage,
        expectedMileage: null,
        date: period.startedAt,
      }
    })
  }

  const v1Periods = periods as ReadonlyArray<RebateSummaryPeriodData>
  return v1Periods.map((period: RebateSummaryPeriodData) => ({
    mileage: period?.accumulatedMileage || null,
    expectedMileage: period?.accumulatedExpectedMileage || null,
    date: period.date,
  }))
}
